import * as FullStory from "@fullstory/browser";
import { ICurrentUser } from "./context";

export const useFullStory = (currentUser: ICurrentUser) => {
  if (
    (process.env.SENTRY_ENV === "production" || process.env.SENTRY_ENV === "staging") &&
    process.env.FULLSTORY_ORG_ID &&
    !FullStory.isInitialized()
  ) {
    FullStory.init({
      orgId: process.env.FULLSTORY_ORG_ID,
    });
  }

  if (currentUser && FullStory.isInitialized()) {
    FullStory.identify(currentUser.id, {
      displayName: currentUser.name,
      email: currentUser.email,
    });
  }
};
